<template>
  <BCard
    class="m-0"
    body-class="hover:bg-[#F9F9F9] rounded-xl border border-[#E5E5E5] hover:cursor-pointer"
    @click="$router.push(`/assignment/manage-partners/${data.partner_id}/show`)"
  >
    <div class="flex items-center justify-between mb-[.25rem]">
      <h2 class="font-semibold m-0 truncate max-w-[60%] text-base">
        {{ data.partner_name }}
      </h2>
      <BButton
        variant="link"
        class="shadow"
      >
        <feather-icon
          icon="ArrowUpRightIcon"
          size="16"
        />
      </BButton>
    </div>
    <div class="flex items-center justify-between">
      <div class="text-[#737373] text-sm">
        <p class="mb-[.25rem]">
          No. Partner: {{ data.no_partner }}
        </p>
        <p class="m-0">
          {{ data.latest_sk_number }}
        </p>
      </div>
      <span
        v-if="data.has_active_churn_request"
        class="bg-primary text-white px-[.75rem] py-[.25rem] rounded-full text-sm"
      >Churn Request</span>
    </div>
    <div class="flex justify-center items-center my-[1.25rem]">
      <hr class="w-full border-[2px]">
      <span class="px-[3rem] whitespace-nowrap">Talent Aktif</span>
      <hr class="w-full border-[2px]">
    </div>
    <div class="space-y-5">
      <TalentRow
        v-for="talent in data.active_talents.slice(0, 3)"
        :key="talent.name"
        :data="talent"
        with-badge
      >
        <template #subTitle>
          <span class="truncate w-[90%] inline-block">Lead: {{ talent.staff_name }}</span>
        </template>
      </TalentRow>
      <p
        v-if="data.total_active_talent > 3"
        class="text-[#0090FF] text-lg mb-0"
      >
        +{{ data.total_active_talent - 3 }} Lainnya
      </p>
    </div>
  </BCard>
</template>

<style scoped>
.btn-link {
    padding: .5rem !important;
    color: black !important;
}
</style>

<script>
import TalentRow from './TalentRow.vue'

export default {
  components: { TalentRow },
  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {

    }
  },
}
</script>
